var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewversion(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 64,
    viewBox: "0 0 88 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M87.1094 32.6683C92.9007 55.7905 69.4568 28.0154 44.8454 41.9015C20.234 55.7876 7.78924 76.8039 1.99797 53.6816C-3.79329 30.5594 10.5648 7.11114 34.0677 1.30847C57.5706 -4.4942 81.3182 9.54607 87.1094 32.6683Z",
    fill: "#EFEFEF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M68 40C68 53.255 57.255 64 44 64C30.745 64 20 53.255 20 40C20 26.745 30.745 16 44 16C57.255 16 68 26.745 68 40Z",
    fill: "url(#paint0_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M49.4059 51.8993C49.4059 52.4633 48.9474 52.9221 48.3834 52.9221H32.8389C32.2749 52.9221 31.8164 52.4633 31.8164 51.8993V28.097C31.8164 27.5331 32.2749 27.0742 32.8389 27.0742H48.3834C48.9474 27.0742 49.4059 27.5331 49.4059 28.097V30.1687H52.2184V28.097C52.2184 25.9822 50.4979 24.2617 48.3834 24.2617H32.8389C30.724 24.2617 29.0039 25.9822 29.0039 28.097V51.8997C29.0039 54.0142 30.7244 55.7346 32.8389 55.7346H48.3834C50.4983 55.7346 52.2184 54.0142 52.2184 51.8997V48.6279H49.4059V51.8993Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9902 29.1289H43.2318V31.9414H37.9902V29.1289Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3965 49.48C39.3965 50.1509 39.9403 50.6943 40.6108 50.6943C41.2817 50.6943 41.8256 50.1509 41.8256 49.48C41.8256 48.8094 41.2817 48.2656 40.6108 48.2656C39.9403 48.2656 39.3965 48.8094 39.3965 49.48Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9512 34.7754V37.5879H53.6111L52.6113 38.5876L54.6002 40.5765L58.9947 36.1816L54.6002 31.7871L52.6113 33.7756L53.6111 34.7754H43.9512Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0143 41.4869L48.0258 39.498L43.6309 43.8929L48.0258 48.2875L50.0143 46.299L49.0145 45.2992H58.7048V42.4867H49.0145L50.0143 41.4869Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 20,
    y1: 40,
    x2: 68,
    y2: 40,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F34F42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B91618"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewversion);
export default __webpack_public_path__ + "static/media/newversion.de9da0eaada8098a8add5aea3c473db2.svg";
export { ForwardRef as ReactComponent };